const state = {
  tooltips: {
    rysuj: 'Rysuj',
    spisTresci: 'Spis treści',
    powieksz: 'Powiększ',
    fullScreen: 'Pełny ekran',
    pierwsza: 'Pierwsza strona',
    poprzednia: 'Poprzednia strona',
    numerStrony: 'Numer strony',
    nastepna: 'Następna',
    ostatnia: 'Ostatnia strona',
    przybornik_pedzel: 'Pędzel',
    przybornik_prostokat: 'Prostokątny obszar',
    przybornik_okrag: 'Eliptyczny obszar',
    przybornik_wyroznij: 'Wyróżnij obszar',
    przybornik_gumka: 'Gumka',
    clearAll: 'Wyczyść wszystko',
    wybranyKolor: 'Wybrany kolor',
    exit: 'Zamknij przybornik',
    macLogo: 'www.mac.pl',
    close: 'Zamknij',
  },
};

const getters = {
  getTooltips: (state) => {
    return state.tooltips;
  },
};
export default {
  state,
  getters,
};
